module.exports = __webpack_public_path__ + "static/design-thinking@2x-a55931bc0fad1cc294bb1040c96ea642.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/agencies-industry-pages/design-thinking@2x.jpg
// module id = 2528
// module chunks = 281026976107462